var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFamilleSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-15,.cls-6{fill:none;}.cls-2{fill:#af975c;opacity:0;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#facfaf;}.cls-11,.cls-5{fill:#3a3e36;}.cls-6{stroke:#facfaf;}.cls-15,.cls-6{stroke-linecap:round;stroke-linejoin:round;stroke-width:0;}.cls-7{fill:#ffe3ba;}.cls-8{fill:#f8b64b;}.cls-9{fill:#ced5dc;}.cls-10{fill:#1a313a;}.cls-11{opacity:0.1;}.cls-12{fill:#55bfeb;}.cls-13{fill:#733925;}.cls-14{fill:#ec6e5b;}.cls-15{stroke:#ffe3ba;}.cls-16{fill:#f1f1f1;}.cls-17{fill:#4c5936;}.cls-18{fill:#415a6b;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 27.5,
    cy: 27.5,
    r: 27.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "famille_selected",
    "data-name": "famille selected"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 55,
    height: 55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.53,34.16l.14-.07,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.8,34.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.89,34l.1,0,.1-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.29,33.73a1.51,1.51,0,0,0,.26-.18A1.51,1.51,0,0,1,40.29,33.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.51,32.74l-.23.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.84,33.34l.24-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.29,35.36a.36.36,0,0,0,0,.11A.36.36,0,0,1,44.29,35.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.76,32.33v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.83,29.85a6,6,0,0,0-2.61-.63h0A6,6,0,0,1,50.83,29.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "51.86 31.46 51.86 31.46 51.86 31.46 52.05 31.41 51.86 31.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.75,31.21h0a6.39,6.39,0,0,0-1.26-1A6.39,6.39,0,0,1,52.75,31.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.7,32.53a4.32,4.32,0,0,0,.34-.39A4.32,4.32,0,0,1,41.7,32.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44,34.42s0,.09,0,.13S44,34.47,44,34.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.13,34.92a.78.78,0,0,0,0,.14A.78.78,0,0,1,44.13,34.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "43.69 31.21 43.69 31.21 43.69 31.21 43.69 31.21 43.69 31.21 43.69 31.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.73,33c0,.05,0,.11,0,.16S43.73,33,43.73,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.07,34.36l.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.28,40l.08-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.89,40.22l0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.65,39.78l.13-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.61,37.88a.48.48,0,0,1-.09.11l.06-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.89,27.66l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51,39.5l.2-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.56,28.21a.54.54,0,0,1,0,.11A.54.54,0,0,0,21.56,28.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.78,36.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.07,27.1,32,27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.5,21a6.71,6.71,0,0,0-1-.57,6.54,6.54,0,0,1-.43.92,6.54,6.54,0,0,0,.43-.92A6.71,6.71,0,0,1,41.5,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.62,20.63h0l-.55.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.14,24.08a2.12,2.12,0,0,0,.08-.41,2.12,2.12,0,0,1-.08.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.89,33.81h1V32.05a10,10,0,0,1-1.6-3.14v-.05a.78.78,0,0,1-.42.17,6.61,6.61,0,0,1,.24,1.81A7.46,7.46,0,0,1,31.43,34a5.24,5.24,0,0,1,.61-.09A7.92,7.92,0,0,1,32.89,33.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.09,32.08h0v1.74h1a6.81,6.81,0,0,1,.78,0v0a1.54,1.54,0,0,1-.69-1.25,1.46,1.46,0,0,1,.54-1.39v-.3c0-.13,0-.26,0-.39A6.27,6.27,0,0,1,44,29a1.23,1.23,0,0,1-.26-.12v0A10,10,0,0,1,42.09,32.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.57,24.35l.32-.23-.32.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.89,24.12a4.48,4.48,0,0,0,.38-.37A4.48,4.48,0,0,1,34.89,24.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,36.35a.75.75,0,0,1-.07.12A.75.75,0,0,0,30,36.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.14,37.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.47,
    y: 38.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.7,38.33l.12,0H30a5.49,5.49,0,0,1,1.07.22,5.27,5.27,0,0,1,.51.19h0a5.27,5.27,0,0,0-.51-.19A5.49,5.49,0,0,0,30,38.37h-.2l-.12,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.36,33a5.92,5.92,0,0,1-3.76-1.33A5.92,5.92,0,0,0,17.36,33l.29,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.25,40.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.11,38.79l.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,37.61a.3.3,0,0,0-.08.08A.3.3,0,0,1,29,37.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.93,38.43l.05,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.68,34c0-.07-.06-.14-.08-.2S21.65,33.91,21.68,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.8,35.64c-.13-.14-.24-.28-.36-.42Q22.61,35.43,22.8,35.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.31,35c-.06-.09-.13-.18-.19-.28C22.18,34.86,22.25,35,22.31,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.66,40.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22,34.52l-.14-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.23,36.47l-.06-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.18,40.45l-.11,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "30.34 35.6 30.34 35.6 30.34 35.6 30.34 35.6 30.34 35.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.45,33.41l0-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.5,21a5.08,5.08,0,0,1,.83.67A5.08,5.08,0,0,0,41.5,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.91,30.29l.06,0-.06,0h0l.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.49,30.57l.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.55,30.53l-.06,0h0l.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.17,30.81l-.06,0,.06,0-.06,0,.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.43,30l.11-.06Zm.11-.06-.11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.74,31.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.79,29.45l-.12,0,.12,0-.12,0,.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.13,29.67l-.06,0,.06,0-.06,0,.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,27.3v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.34,21.33c-.07.13-.15.28-.25.44C39.19,21.61,39.27,21.46,39.34,21.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.09,22.11c.31-.26.63-.56,1-.89C38.72,21.55,38.4,21.85,38.09,22.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.6,28.35l0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.72,22.3q-.18.22-.39.45Q38.54,22.53,38.72,22.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.33,26.36a2.2,2.2,0,0,1-.2.23h0A2.2,2.2,0,0,0,44.33,26.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.54,29.29l-.14,0,.14,0-.14,0,.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.08,27.11v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.89,31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.07,29.86s0-.07,0-.1a.08.08,0,0,0,0,0S21.08,29.84,21.07,29.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,17.78l-.41,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.68,18.81v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.86,19.56v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.36,16.6l-.11.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.94,19.9l0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.59,17.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.86,19.56v.06l0,.15v.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,16.11l-.11.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.14,23.08c.07-.31.13-.61.18-.93C24.27,22.47,24.21,22.77,24.14,23.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.87,31.12h-1a3.23,3.23,0,0,1-2.15-.83,3.23,3.23,0,0,0,2.15.83h1a2.81,2.81,0,0,0,.65-.07h0A3.51,3.51,0,0,1,17.87,31.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.22,21.33v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.27,21.63v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.16,21v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,20.24v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.32,22.19a12.83,12.83,0,0,0-.31-2v0l.06.25v.08c0,.11.05.22.07.33V21c0,.09,0,.17.05.26v.08c0,.08,0,.15,0,.22v.09a1.23,1.23,0,0,1,0,.19v0a.25.25,0,0,1,0,.08h0a2.32,2.32,0,0,1,0,.24h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.53,16.42a1.14,1.14,0,0,1,.11-.11A1.14,1.14,0,0,0,11.53,16.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.37,21.67v-.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.37,21.54v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.69,17.91v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.38,20.75v-.09h0v0a1.7,1.7,0,0,0,0,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.37,21.17v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.38,22.21v-.07h0v0h0a2.45,2.45,0,0,1,0-.3c0,.23,0,.38,0,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.52,22.92a7.09,7.09,0,0,1-.14-.78h0A7.09,7.09,0,0,0,10.52,22.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.71,18.94c0,.08.05.18.07.29h0l0,.08,0,.15v.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.92,17.43c0,.07-.05.14-.08.22C10.87,17.57,10.89,17.5,10.92,17.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.12,17a1.63,1.63,0,0,0-.09.19A1.63,1.63,0,0,1,11.12,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.41,20.12c0,.08,0,.16,0,.23S10.41,20.2,10.41,20.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.76,17.93a1.05,1.05,0,0,0-.06.24A1.05,1.05,0,0,1,10.76,17.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.63,18.46c0,.08,0,.17-.05.25C10.6,18.63,10.61,18.54,10.63,18.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.44,19.82h0a.28.28,0,0,1,0-.09.2.2,0,0,0,0,.07.2.2,0,0,1,0-.07c0-.05,0-.1,0-.16s0,.17,0,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.53,19l0,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.93,19.89v0c0,.06,0,.11,0,.17l0,.11A3,3,0,0,0,23.93,19.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.71,32.85a5.82,5.82,0,0,0,2.35-1.13h0a5.92,5.92,0,0,1-2.33,1.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21 30.84 21 30.84 21 30.84 21 30.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18,33h0a5.58,5.58,0,0,0,.57-.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.73,38.83h0l0,0,0,0h0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.34,38.33h0a6.24,6.24,0,0,0-2,.5l-.17.09.17-.09A6.24,6.24,0,0,1,23.34,38.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.07,34.36h0l.21-.08-.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.52,34.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44,37.36a8.7,8.7,0,0,1-.69.67A8.7,8.7,0,0,0,44,37.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.49,34.18l.18-.09-.14.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M43.09,38.21a6.7,6.7,0,0,1-.6.45A6.7,6.7,0,0,0,43.09,38.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.8,34.45l-.07,0,.16-.06,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.83,39.05c.12-.06.22-.13.34-.2l-.6.33C41.66,39.13,41.75,39.1,41.83,39.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.61,34.51l-.17.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.87,34.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.34,34.59l-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.14,34.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38,34.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.89,34l.1,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.78,36.41h0a8.64,8.64,0,0,1-.69.88,8.51,8.51,0,0,0,.69-.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33.89,32.05v1.76h-1a7.92,7.92,0,0,0-.85,0,5.24,5.24,0,0,0-.61.09,6.9,6.9,0,0,1-.88,1.4.56.56,0,0,0,0,.12A8.27,8.27,0,0,0,38,40,8.47,8.47,0,0,0,39,40a8.36,8.36,0,0,0,1.94-.49,3.62,3.62,0,0,0,.45-.2L36.14,34A7.1,7.1,0,0,1,33.89,32.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "42.1 33.81 42.1 32.07 42.1 32.07 42.1 33.82 43.06 33.82 43.07 33.81 43.06 33.81 42.1 33.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.89,26.75a1,1,0,0,0,.09.15h0L32,27h0l.06.14.06.16.09.22s.13-.18.28-.44a.41.41,0,0,0,0,.09.41.41,0,0,1,0-.09l.09-.17a.93.93,0,0,1,0-.1.93.93,0,0,0,0,.1s0,0,0-.05a3.72,3.72,0,0,0,.24-.58h0a1.29,1.29,0,0,0,0-.58,3.07,3.07,0,0,1,1.63-2.15,6.29,6.29,0,0,1,1.32-.61,2.13,2.13,0,0,1-.16.31,3.52,3.52,0,0,1-.4.55,4.48,4.48,0,0,1-.38.37l-.32.23a5.21,5.21,0,0,0,1.09-.49l.31-.18c.23-.13.47-.29.74-.47s.55-.41.86-.65l.52-.45c.31-.26.63-.56,1-.89l0,0,.55-.57h0a4.52,4.52,0,0,1-.28.7c-.07.13-.15.28-.25.44s-.1.16-.15.24l-.22.29q-.18.22-.39.45a4.58,4.58,0,0,1-1.2.87,4.82,4.82,0,0,0,2.94-2.27,6.54,6.54,0,0,0,.43-.92,6.71,6.71,0,0,1,1,.57,5.08,5.08,0,0,1,.83.67,3.07,3.07,0,0,1,.81,1.24,2.14,2.14,0,0,1,.08.76,2.12,2.12,0,0,1-.08.41l.55,3.4.35-.77.09-.12h0a2.2,2.2,0,0,0,.2-.23c.14-.17.26-.34.38-.51h0c2-3.07-.15-6.63-.15-6.63-2.8-4.67-6.28-3.64-6.28-3.64l-.5,0a5.5,5.5,0,0,0-4.71,1.49,7.12,7.12,0,0,0-1.86,8.23,9.2,9.2,0,0,0,.7,1.44Zm.87-.25,0,.1Zm-.4.77,0,.06Zm-.09.14,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.33,26.36a2.2,2.2,0,0,1-.2.23c0,.18,0,.35-.05.52v.06c0,.1,0,.21,0,.31h.07a5.4,5.4,0,0,0,.54-1.24,3.25,3.25,0,0,0,.07-.38h0C44.59,26,44.47,26.19,44.33,26.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.85,26.24h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.59,26.87a.93.93,0,0,1,0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.71,26.6l0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.45,27.13a.41.41,0,0,1,0-.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32,26.91h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32,27.3v-.06c0-.15,0-.32-.05-.49l0,0a9.2,9.2,0,0,1-.7-1.44h0a5.09,5.09,0,0,0,.12.89,3.74,3.74,0,0,0,.49,1.22.47.47,0,0,1,.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.24,27.44l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.32,27.33l0-.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M33.89,32.05A7.1,7.1,0,0,0,36.14,34h0l.37.2h0l.35.15h0a4.72,4.72,0,0,0,1.13.32h.14l.06,0,.14,0,.1,0,.17-.05.12,0,.07,0h0l0,0,.15-.05h0l.07,0,.11,0,.24-.11,0,0,.17-.09.19-.1h0l.2-.11a1.37,1.37,0,0,0,.2-.13,1.51,1.51,0,0,0,.26-.18c.1-.06.19-.14.29-.21l.24-.2.2-.18.23-.22.19-.21a4.32,4.32,0,0,0,.34-.39l.05-.06h0a10,10,0,0,0,1.63-3.17v0a.77.77,0,0,1-.35-.64.77.77,0,0,1,.66-.76c0-.1,0-.21,0-.31v-.06c0-.17,0-.34.05-.52h0l-.09.12-.35.77-.55-3.4h0a2.12,2.12,0,0,0,.08-.41,2.14,2.14,0,0,0-.08-.76,3.07,3.07,0,0,0-.81-1.24A5.08,5.08,0,0,0,41.5,21a6.71,6.71,0,0,0-1-.57,6.54,6.54,0,0,1-.43.92,4.82,4.82,0,0,1-2.94,2.27,4.58,4.58,0,0,0,1.2-.87q.21-.22.39-.45l.22-.29c.05-.08.11-.16.15-.24s.18-.31.25-.44a4.52,4.52,0,0,0,.28-.7h0l-.55.57,0,0c-.33.33-.65.63-1,.89l-.52.45c-.31.24-.59.46-.86.65s-.51.34-.74.47l-.31.18a5.21,5.21,0,0,1-1.09.49h0l.32-.23a4.48,4.48,0,0,0,.38-.37,3.52,3.52,0,0,0,.4-.55,2.13,2.13,0,0,0,.16-.31,6.29,6.29,0,0,0-1.32.61,3.07,3.07,0,0,0-1.63,2.15,1.29,1.29,0,0,1,0,.58h0a3.72,3.72,0,0,1-.24.58s0,0,0,.05L32.5,27c-.15.26-.28.44-.28.44l-.09-.22-.06-.16L32,27h0l0-.05a1,1,0,0,1-.09-.15c0,.17,0,.34.05.49v.06l0,.19a.76.76,0,0,1,.3,1.37v.05A10,10,0,0,0,33.89,32.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M12.57,30.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.78,19.23l0,.08,0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24,20.21l0-.11,0,.07v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.29,21.83h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.85,19.51v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.21,21.25v.08h0v-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.08,20.59v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.26,21.55v.08h0v-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.15,20.93v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.92,19.85v0l0,.08v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.32,22.19h0v0h0c-.05.32-.11.62-.18.93s-.07.33-.11.49v0a2.38,2.38,0,0,0,1.18-2,3,3,0,0,0-.2-1.36l0,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.3,21.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M10.45,19.73a.2.2,0,0,0,0,.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M10.38,20.66h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M10.37,21.53h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M10.38,20.75V20.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M10.37,21.14v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.38,22.14h0v0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.38,22.14v.07h0l-.68-2h0a2.88,2.88,0,0,0-.21,1.41,2.31,2.31,0,0,0,1.19,2h0c-.05-.22-.11-.45-.15-.68A7.09,7.09,0,0,1,10.38,22.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M10.38,22.21h0s0-.15,0-.38V21.1a2.18,2.18,0,0,1,0-.25,1.7,1.7,0,0,1,0-.22,2.72,2.72,0,0,1,0-.28c0-.07,0-.15,0-.23l0-.3c0-.08,0-.16,0-.25s0-.2,0-.3l0-.25c0-.11,0-.21.05-.31s0-.17.05-.25a2.46,2.46,0,0,1,.07-.29,1.05,1.05,0,0,1,.06-.24,2.29,2.29,0,0,1,.08-.28c0-.08.05-.15.08-.22s.07-.17.11-.26a1.63,1.63,0,0,1,.09-.19,1.59,1.59,0,0,1,.13-.22l.11-.16a1.45,1.45,0,0,1,.17-.18,1.14,1.14,0,0,1,.11-.11,1,1,0,0,1,.23-.13l.11-.07a1.23,1.23,0,0,1,.39-.07s3.42,1.36,5,1.75a7,7,0,0,0,.86,0h.34l.41,0a5.45,5.45,0,0,0,3.67-1.7,2.27,2.27,0,0,1,.83.93,1.65,1.65,0,0,1,.14.41,2.54,2.54,0,0,1,.05.49v0a3,3,0,0,1-.09.55s0,.1.07.27v0l0,.13.14.57v0l.06.29v0a3,3,0,0,1,.07.32v0a12.83,12.83,0,0,1,.31,2h0L25,20.32l0-.09c.35-1.1,1.4-5.25-2-6.29,0,0-.27-4-5.92-4.48,0,0-4.16-.21-7.55,4.5l.82-.33s-1.58,1-.64,6.57h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "12.57 30.59 12.56 30.59 12.57 30.59 12.57 30.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M18,43.09a5.68,5.68,0,0,1,3.14-4.17h0l.17-.09a6.24,6.24,0,0,1,2-.5h.3V37.08a7.19,7.19,0,0,1-.41-.61l-.06-.1a7.08,7.08,0,0,1-.37-.73h0q-.19-.21-.36-.42L22.31,35c-.06-.09-.13-.18-.19-.28s-.1-.16-.15-.24l-.14-.25L21.68,34c0-.07-.06-.14-.08-.2a2.39,2.39,0,0,1-.15-.37l0-.09v0a7.41,7.41,0,0,1-9.92-1.73l0,0a1.42,1.42,0,0,1-.27-.48l.89-.32L4.2,33.6A6.62,6.62,0,0,0,.53,36.88a27.2,27.2,0,0,0,2.89,7.9l14.46,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21.19,32.51v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M13,31.12A5.89,5.89,0,0,0,17.36,33h0a5.92,5.92,0,0,1-3.76-1.33A6.33,6.33,0,0,1,13,31.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M12.57,30.59h0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M21.19,32.51a6.51,6.51,0,0,1-.13-.79,5.82,5.82,0,0,1-2.35,1.13l-.19,0A5.58,5.58,0,0,1,18,33a2.89,2.89,0,0,1-.29,0h0l-.29,0h0A5.89,5.89,0,0,1,13,31.12c-.14-.15-.27-.31-.4-.48l0,0,0,0h0l-.46.17-.89.32a1.42,1.42,0,0,0,.27.48l0,0a7.41,7.41,0,0,0,9.92,1.73c-.08-.24-.15-.49-.21-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M21.06,29.93v-.07s0,0,0-.06S21.07,29.89,21.06,29.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M17.65,33h0l.3,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "21 30.84 21 30.84 21 30.84 21 30.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M18.52,31.05a3.17,3.17,0,0,0,1.53-.79,3.27,3.27,0,0,1-1.52.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M18.51,32.9h0l.19,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M17.66,33A2.89,2.89,0,0,0,18,33l-.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M17.66,33A2.89,2.89,0,0,0,18,33l-.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M18.71,32.85l-.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M18.71,32.85l-.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.57,30.59h0l0,0,0,0c.13.17.26.33.4.48a6.33,6.33,0,0,0,.59.57A5.92,5.92,0,0,0,17.36,33l.29,0L18,33l.55-.07.22-.06a5.92,5.92,0,0,0,2.33-1.12,6.4,6.4,0,0,1-.06-.88h0a8.69,8.69,0,0,1,.06-.91s0-.09,0-.13a.08.08,0,0,1,0,0,5,5,0,0,1,.18-.81h0c-.11.12-.2.25-.31.36l-.68.74a2.29,2.29,0,0,1-.23.21,3.17,3.17,0,0,1-1.53.79,2.81,2.81,0,0,1-.65.07h-1a3.23,3.23,0,0,1-2.15-.83,2.85,2.85,0,0,1-.26-.23l-.68-.74a14.47,14.47,0,0,1-1.19-1.52v2.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M14.43,30.06a2.85,2.85,0,0,0,.26.23,3.23,3.23,0,0,0,2.15.83h1a3.51,3.51,0,0,0,.66-.07,3.27,3.27,0,0,0,1.52-.79,2.29,2.29,0,0,0,.23-.21l.68-.74c.11-.11.2-.24.31-.36h0a4.32,4.32,0,0,1,.24-.63.54.54,0,0,0,0-.11c.1-.18.2-.36.31-.52l0,0a4.37,4.37,0,0,1,.92-.95h0A13.63,13.63,0,0,0,24,23.57c0-.16.08-.33.11-.49s.13-.61.18-.93h0a2.32,2.32,0,0,0,0-.24h0a.25.25,0,0,0,0-.08h0a1.23,1.23,0,0,0,0-.19h0v-.08h0c0-.07,0-.14,0-.22h0v-.08h0c0-.09,0-.17-.05-.26v-.06h0c0-.11,0-.22-.07-.33v-.08L24,20.26v-.09l0-.07c0-.06,0-.11,0-.17v0l0-.08v-.05l0-.15v-.16l0-.15,0-.08c0-.11-.05-.21-.07-.29l0-.13v0c0-.17-.07-.27-.07-.27a3,3,0,0,0,.09-.55v0a2.54,2.54,0,0,0-.05-.49A1.65,1.65,0,0,0,23.5,17a2.27,2.27,0,0,0-.83-.93A5.45,5.45,0,0,1,19,17.78l-.41,0h-.34a7,7,0,0,1-.86,0c-1.6-.39-5-1.75-5-1.75a1.23,1.23,0,0,0-.39.07l-.11.07a1,1,0,0,0-.23.13,1.14,1.14,0,0,0-.11.11,1.45,1.45,0,0,0-.17.18l-.11.16a1.59,1.59,0,0,0-.13.22,1.63,1.63,0,0,0-.09.19c0,.09-.08.17-.11.26s-.05.14-.08.22a2.29,2.29,0,0,0-.08.28,1.05,1.05,0,0,0-.06.24,2.46,2.46,0,0,0-.07.29c0,.08,0,.17-.05.25s0,.2-.05.31l0,.25c0,.1,0,.2,0,.3s0,.11,0,.16a.28.28,0,0,0,0,.09h0l0,.3c0,.08,0,.16,0,.23a2.72,2.72,0,0,0,0,.28v.22a2.18,2.18,0,0,0,0,.25v.72a2.45,2.45,0,0,0,0,.3v0h0a7.09,7.09,0,0,0,.14.78c0,.23.1.46.15.68a13.49,13.49,0,0,0,1.89,4.2,14.47,14.47,0,0,0,1.19,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M31.6,28.35a4.57,4.57,0,0,1,.26.68.78.78,0,0,0,.42-.17.76.76,0,0,0-.3-1.37.47.47,0,0,0-.16,0h0a.79.79,0,0,0-.58.26h0a4.61,4.61,0,0,1,.33.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.93,38.43l.05,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.54,43.38a4.83,4.83,0,0,0,3.68-1.53A4.69,4.69,0,0,1,29,42.7l-3.82-4.24h0a4.47,4.47,0,0,1-1.1-.82h0a6.68,6.68,0,0,1-.5-.55v1.25h-.3a6.24,6.24,0,0,0-2,.5l-.17.09h0v0a3,3,0,0,0,.29.86C22.56,42,24.06,43.38,26.54,43.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.93,37.69h0a.47.47,0,0,1,.1-.1h0A.3.3,0,0,0,28.93,37.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.65,38.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26,38.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30,38.37h-.2a13.22,13.22,0,0,1,1.78.42,5.27,5.27,0,0,0-.51-.19A5.49,5.49,0,0,0,30,38.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.51,38.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.76,38.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.11,38.79h0l.07,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "29.47 37.09 29.47 37.09 29.47 37.09 29.47 37.1 29.47 37.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.18,38.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M22.5,34.84s-.1-.34-.19-.84h0a2.44,2.44,0,0,1-.49-1.06c-.17-.74-.08-1.39.2-1.46a.34.34,0,0,1,.28.11h0c.49-.17,1.27-.76,2.21-2.65C25,30,27.11,31,28.83,31.41h0l1.43-.77a.28.28,0,0,1,.15,0h0a.34.34,0,0,1,.29.17.33.33,0,0,1,0,.32h0a.27.27,0,0,1-.13.13l-.68.37.33,0h.53c.11-.12.22-.18.32-.13.28.14.34,1,.2,1.46a3.35,3.35,0,0,1-.44,1h0a6.9,6.9,0,0,1-.21.92c-.09.28-.18.52-.28.76h0l.21-.25h0a6.9,6.9,0,0,0,.88-1.4,7.46,7.46,0,0,0,.67-3.11A6.61,6.61,0,0,0,31.86,29a4.57,4.57,0,0,0-.26-.68l0-.06a4.61,4.61,0,0,0-.33-.58,5.4,5.4,0,0,0-4.69-2.1,6.09,6.09,0,0,0-3.74,1.1,4.37,4.37,0,0,0-.92.95l0,0c-.11.16-.21.34-.31.52a.54.54,0,0,1,0,.11,4.32,4.32,0,0,0-.24.63,5,5,0,0,0-.18.81s0,.07,0,.1v.07a8.69,8.69,0,0,0-.06.91h0a6.4,6.4,0,0,0,.06.88h0a6.51,6.51,0,0,0,.13.79v.05c.06.25.13.5.21.74v0l0,.09a2.39,2.39,0,0,0,.15.37c0,.06,0,.13.08.2l.15.29.14.25c.05.08.09.16.15.24s.13.19.19.28l.13.18c.12.14.23.28.36.42h0C22.7,35.39,22.59,35.13,22.5,34.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M22.23,33.44s0,.07,0,.1S22.23,33.47,22.23,33.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M22.21,32.22c0,.06,0,.11,0,.17S22.2,32.28,22.21,32.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.93,32.81a1.09,1.09,0,0,1,0,.18A1.09,1.09,0,0,0,30.93,32.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M22.2,33c0-.06,0-.11,0-.17S22.2,33,22.2,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.92,32.41a1.21,1.21,0,0,0,0-.19A1.21,1.21,0,0,1,30.92,32.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.89,33.48a.28.28,0,0,1,0-.09A.28.28,0,0,0,30.89,33.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M31.81,38.87l0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M30.22,41.85a4.83,4.83,0,0,1-3.68,1.53c-2.48,0-4-1.37-5.09-3.58a3,3,0,0,1-.29-.86v0A5.7,5.7,0,0,0,18,43.09l-.29,3.34H35.34l-.29-3.34a5.68,5.68,0,0,0-3.14-4.17.08.08,0,0,1,0,0,3.47,3.47,0,0,1-.26.81A7.63,7.63,0,0,1,30.22,41.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M28,38.4l0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M29.42,38.33a2.69,2.69,0,0,1,.4,0l-.12,0h-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M31.66,38.81l.07,0h0l-.13,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.66,38.81l-.06,0a13.22,13.22,0,0,0-1.78-.42,2.69,2.69,0,0,0-.4,0h0V37.09h0c-.15.18-.3.35-.45.5a.47.47,0,0,0-.1.1,5.07,5.07,0,0,1-.9.68l0,0-.05,0a4.63,4.63,0,0,1-.76.34l-.07,0a2.81,2.81,0,0,1-.45.12h-.09a1.88,1.88,0,0,1-.38-.08h0L26,38.78h0l-.21-.08h0l-.23-.1h0l-.24-.13h0L29,42.7a4.69,4.69,0,0,0,1.18-.85,8.36,8.36,0,0,0,1.42-2.08A3.47,3.47,0,0,0,31.9,39a.08.08,0,0,0,0,0,.61.61,0,0,0-.14-.07l-.11-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M31.66,38.81l-.06,0a13.22,13.22,0,0,0-1.78-.42,2.69,2.69,0,0,0-.4,0h0V37.09h0c-.15.18-.3.35-.45.5a.47.47,0,0,0-.1.1,5.07,5.07,0,0,1-.9.68l0,0-.05,0a4.63,4.63,0,0,1-.76.34l-.07,0a2.81,2.81,0,0,1-.45.12h-.09a1.88,1.88,0,0,1-.38-.08h0L26,38.78h0l-.21-.08h0l-.23-.1h0l-.24-.13h0L29,42.7a4.69,4.69,0,0,0,1.18-.85,8.36,8.36,0,0,0,1.42-2.08A3.47,3.47,0,0,0,31.9,39a.08.08,0,0,0,0,0,.61.61,0,0,0-.14-.07l-.11-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M31.66,38.81h0l.11.05,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M31.66,38.81h0l.11.05,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M31.64,39.77a8.36,8.36,0,0,1-1.42,2.08A7.63,7.63,0,0,0,31.64,39.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M31.64,39.77a8.36,8.36,0,0,1-1.42,2.08A7.63,7.63,0,0,0,31.64,39.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M31.9,39a3.47,3.47,0,0,1-.26.81A3.47,3.47,0,0,0,31.9,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M31.9,39a3.47,3.47,0,0,1-.26.81A3.47,3.47,0,0,0,31.9,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M30.71,30.77a.34.34,0,0,0-.29-.17l.14,0-.14,0h0a.28.28,0,0,0-.15,0l-1.43.77a.33.33,0,1,0,.32.58l1.42-.77a.27.27,0,0,0,.13-.13A.33.33,0,0,0,30.71,30.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M30.7,31.09a.27.27,0,0,1-.13.13A.27.27,0,0,0,30.7,31.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M30.26,30.64a.28.28,0,0,1,.15,0A.28.28,0,0,0,30.26,30.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.27,32.94c.14-.43.08-1.32-.2-1.46-.1-.05-.21,0-.32.13h.07a3.1,3.1,0,0,1,.09.61,1.21,1.21,0,0,1,0,.19c0,.14,0,.27,0,.4a1.09,1.09,0,0,1,0,.18c0,.13,0,.27,0,.4a.28.28,0,0,0,0,.09c0,.16,0,.3-.06.44h0A3.35,3.35,0,0,0,31.27,32.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22,31.48c-.28.07-.37.72-.2,1.46A2.44,2.44,0,0,0,22.31,34h0c0-.14,0-.29-.07-.46s0-.07,0-.1,0-.28,0-.43,0-.11,0-.17,0-.3,0-.45,0-.11,0-.17.05-.42.09-.63h0A.34.34,0,0,0,22,31.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M30.42,30.6h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M30.56,30.63l-.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M30.26,30.64a.28.28,0,0,1,.15,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 30.41,
    y1: 30.6,
    x2: 30.41,
    y2: 30.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M30.7,31.09a.27.27,0,0,1-.13.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M24.14,37.63h0a4.47,4.47,0,0,0,1.1.82l.24.13h0l.23.1h0l.21.08h0l.18.06h0a1.88,1.88,0,0,0,.38.08h.09a2.81,2.81,0,0,0,.45-.12h0l.05,0h0a4.63,4.63,0,0,0,.76-.34h0l.09,0h0a5.07,5.07,0,0,0,.9-.68h0a.3.3,0,0,1,.08-.08h0c.15-.15.3-.32.45-.5h0a4.2,4.2,0,0,0,.42-.62.75.75,0,0,0,.07-.12,7.47,7.47,0,0,0,.38-.75h0c.1-.24.19-.48.28-.76a6.9,6.9,0,0,0,.21-.92c0-.14,0-.28.06-.44a.28.28,0,0,1,0-.09c0-.13,0-.27,0-.4a1.09,1.09,0,0,0,0-.18c0-.13,0-.26,0-.4a1.21,1.21,0,0,0,0-.19,3.1,3.1,0,0,0-.09-.61h-.6l-.33,0,.68-.37L29.15,32a.33.33,0,1,1-.32-.58h0C27.11,31,25,30,24.51,28.93c-.94,1.89-1.72,2.48-2.21,2.65h0q-.06.32-.09.63c0,.06,0,.11,0,.17s0,.3,0,.45,0,.11,0,.17,0,.29,0,.43,0,.07,0,.1,0,.32.07.46c.09.5.19.84.19.84.09.29.2.55.3.8a7.08,7.08,0,0,0,.37.73l.06.1a7.19,7.19,0,0,0,.41.61A6.68,6.68,0,0,0,24.14,37.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M42.51,40.42l2.61-1.24h0V37c-.11-.17-.22-.35-.32-.53h0a8.51,8.51,0,0,1-.69.87l-.07.07a8.7,8.7,0,0,1-.69.67l-.24.18a6.7,6.7,0,0,1-.6.45l-.32.19c-.12.07-.22.14-.34.2s-.17.08-.26.13l-.18.09h0a3.62,3.62,0,0,1-.45.2A8.36,8.36,0,0,1,39,40,8.47,8.47,0,0,1,38,40a8.27,8.27,0,0,1-7.38-4.54.56.56,0,0,1,0-.12h0l-.21.25h0a7.47,7.47,0,0,1-.38.75.75.75,0,0,1-.07.12,4.2,4.2,0,0,1-.42.62h0v1.24h.23l.12,0H30a5.49,5.49,0,0,1,1.07.22,5.27,5.27,0,0,1,.51.19h0l.13,0h0l0,0,0,0,.1.05h0a5.68,5.68,0,0,1,3.14,4.17l.15,1.69h4.72V44A3.72,3.72,0,0,1,42.51,40.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "31.8 38.86 31.81 38.87 31.81 38.87 31.81 38.87 31.81 38.87 31.8 38.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M40.84,33.34l-.08.06.35-.28,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M44.18,35.06a.78.78,0,0,1,0-.14h0a.78.78,0,0,0,0,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M41.28,33l0,0,.31-.31-.05.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M44.33,35.47a.36.36,0,0,1,0-.11h0a.36.36,0,0,0,0,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M40.29,33.73h0c.11-.08.23-.15.34-.24l-.08,0A1.51,1.51,0,0,1,40.29,33.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M43.07,33.81a6.81,6.81,0,0,1,.78,0h0a6.81,6.81,0,0,0-.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M44,34.55s0-.08,0-.13h0s0,.09,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M42.09,32.08l-.05.06a4.32,4.32,0,0,1-.34.39l0,0c.14-.15.28-.31.42-.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M40,33.92l.12-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M39.67,34.09l0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.78,36.41c-.11-.2-.21-.4-.31-.61l-.14-.33a.36.36,0,0,1,0-.11,2.09,2.09,0,0,1-.11-.3.78.78,0,0,1,0-.14c0-.12-.08-.24-.11-.37s0-.08,0-.13-.09-.36-.13-.56a6.81,6.81,0,0,0-.78,0h-1V32.07c-.14.18-.28.34-.42.49l-.12.12-.31.31-.14.13-.35.28-.13.1c-.11.09-.23.16-.34.24l-.18.11-.12.07-.1,0-.18.1,0,0-.18.09-.24.11-.21.08-.15.05-.16.06-.12,0-.17.05-.1,0-.14,0-.06,0H38a4.72,4.72,0,0,1-1.13-.32h0l-.35-.15h0l-.37-.2,5.24,5.28.19-.08.6-.33.32-.19a6.7,6.7,0,0,0,.6-.45l.24-.18a8.7,8.7,0,0,0,.69-.67l.07-.07a8.64,8.64,0,0,0,.69-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M44.78,36.41c-.11-.2-.21-.4-.31-.61l-.14-.33a.36.36,0,0,1,0-.11,2.09,2.09,0,0,1-.11-.3.78.78,0,0,1,0-.14c0-.12-.08-.24-.11-.37s0-.08,0-.13-.09-.36-.13-.56a6.81,6.81,0,0,0-.78,0h-1V32.07c-.14.18-.28.34-.42.49l-.12.12-.31.31-.14.13-.35.28-.13.1c-.11.09-.23.16-.34.24l-.18.11-.12.07-.1,0-.18.1,0,0-.18.09-.24.11-.21.08-.15.05-.16.06-.12,0-.17.05-.1,0-.14,0-.06,0H38a4.72,4.72,0,0,1-1.13-.32h0l-.35-.15h0l-.37-.2,5.24,5.28.19-.08.6-.33.32-.19a6.7,6.7,0,0,0,.6-.45l.24-.18a8.7,8.7,0,0,0,.69-.67l.07-.07a8.64,8.64,0,0,0,.69-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.7,34.07h0l.18-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M39.7,34.07h0l.18-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M40.09,33.86h0l.18-.11h0A1.37,1.37,0,0,1,40.09,33.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M40.09,33.86h0l.18-.11h0A1.37,1.37,0,0,1,40.09,33.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M41.51,32.74l.05-.06.12-.12,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M41.51,32.74l.05-.06.12-.12,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M42.09,32.08l-.05.06.05-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M42.09,32.08l-.05.06.05-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M40.55,33.55l.08,0,.13-.1.08-.06C40.74,33.41,40.65,33.49,40.55,33.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M40.55,33.55l.08,0,.13-.1.08-.06C40.74,33.41,40.65,33.49,40.55,33.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M41.08,33.14l0,0,.14-.13,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M41.08,33.14l0,0,.14-.13,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M38,34.65a4.72,4.72,0,0,1-1.13-.32A4.72,4.72,0,0,0,38,34.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M38,34.65a4.72,4.72,0,0,1-1.13-.32A4.72,4.72,0,0,0,38,34.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M36.87,34.33l-.35-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M36.87,34.33l-.35-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M38.2,34.61l-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M38.2,34.61l-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M38.07,34.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M38.07,34.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M36.14,34l.37.2-.37-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M36.14,34l.37.2-.37-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.49,34.18l-.24.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M39.49,34.18l-.24.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39,34.37l-.15.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M39,34.37l-.15.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M38.44,34.56l-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M38.44,34.56l-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M38.73,34.48l-.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M38.73,34.48l-.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M41.39,39.27l.18-.09-.19.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M41.39,39.27l.18-.09-.19.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M43.33,38l-.24.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M43.33,38l-.24.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M44.09,37.29l-.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M44.09,37.29l-.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M42.49,38.66l-.32.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M43.37,28.24a.77.77,0,0,0,.35.64A1.23,1.23,0,0,0,44,29a5.51,5.51,0,0,1,.63-1.39.79.79,0,0,0-.45-.16l-.06,0H44A.77.77,0,0,0,43.37,28.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M47.54,29.29l-.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M44.17,30.81l-.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M46.79,29.45l-.12,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M44.91,30.29l.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M43.89,31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M46.13,29.67l-.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M44.49,30.57l.06,0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "43.69 31.22 43.7 31.22 43.7 31.22 43.69 31.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M47.71,30.24l.5,0A2.85,2.85,0,0,0,47.71,30.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.6,31.07a.81.81,0,0,1,.14.12l0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M48.23,30.21a3.57,3.57,0,0,1,.72.07A3.57,3.57,0,0,0,48.23,30.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M46.63,30.56l-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M46.18,30.82l-.08.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.31,30.84l-.23-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M49.87,30.58l-.24-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M51.47,31.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M47,30.4l-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M49.44,30.41l-.16-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "52.75 31.22 52.75 31.22 52.19 31.37 52.75 31.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M47.44,30.29l-.09,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "51.86 31.46 52.06 31.4 52.05 31.41 51.86 31.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M49.06,30.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M52.37,34.79l-.09.22.09-.22a7.79,7.79,0,0,0,.24-1h0A7.79,7.79,0,0,1,52.37,34.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M52.75,31.22v1.11h0V31a1.62,1.62,0,0,1,0,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M43.69,31.21h0v1a6.06,6.06,0,0,0,0,.75c0,.05,0,.11,0,.16,0,.23.06.46.1.67h0v0h0c0,.2.08.38.13.56h0s0,.09,0,.13h0c0,.13.07.25.11.37h0a.78.78,0,0,0,0,.14h0a2.09,2.09,0,0,0,.11.3h0a.36.36,0,0,0,0,.11h0l.14.33c.1.21.2.41.31.61h0c.1.18.21.36.32.53h0a9,9,0,0,0,.82,1l.42.48a2.11,2.11,0,0,0,1.54.68h.66a2.08,2.08,0,0,0,1.54-.68l.43-.48a.48.48,0,0,0,.09-.11c.16-.18.31-.37.45-.56l.27-.39a9.82,9.82,0,0,0,.87-1.71l-8.51-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M52.76,30.84c0-.14,0-.28,0-.41,0,.19,0,.37,0,.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M43.74,31.17h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M45.54,29.94l-.11.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M43.69,31c0-.18,0-.35,0-.52,0,.13,0,.26,0,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50.15,40.09l.13-.07.08-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50.57,39.84l.08-.06.13-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.89,39.15h.66a2.08,2.08,0,0,0,1.54-.68l.43-.47.06-.08-.06.07-.43.48a2.08,2.08,0,0,1-1.54.68h-.66a2.11,2.11,0,0,1-1.54-.68L45.93,38a9,9,0,0,1-.82-1h0v2.21h0a4.15,4.15,0,0,0,3.11,1.39h0l.4,0h0a2.7,2.7,0,0,0,.41-.06l.11,0,.31-.08-1.63-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51,39.52l0,0,.2-.2A2.39,2.39,0,0,1,51,39.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.68,40.3l.21-.08,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "51.33 39.17 51.33 39.17 51.33 38.12 51.33 39.17 51.33 39.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51.22,37.11l.11,0v-.13h0l-.27.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M51.33,39.17h0l-.13.13-.2.2,0,0-.19.16-.13.1-.08.06-.21.13-.08.05-.13.07-.23.11,0,0-.21.08-.19.07h0l-.31.08-.11,0a2.7,2.7,0,0,1-.41.06h0l-.4,0h0a4.15,4.15,0,0,1-3.11-1.39h0l-2.61,1.24A3.72,3.72,0,0,0,39.92,44v2.56h10.6a27.31,27.31,0,0,0,3-6.29l-2.22-1.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "43.69 31.21 43.69 31.22 43.7 31.22 43.69 31.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M43.71,30.48c0,.17,0,.34,0,.52v.21h0l0,0h0l.13-.12h0l.22-.19.06,0h0l.32-.23h0l.06,0h0l.36-.24h0l.06,0,.46-.25.11-.06c.17-.08.34-.17.53-.24l.06,0h0l.54-.19.12,0h0a4.15,4.15,0,0,1,.61-.14l.14,0h0a5.05,5.05,0,0,1,.68-.07h0a6,6,0,0,1,2.61.63c.23.12.46.24.66.37a6.39,6.39,0,0,1,1.26,1h0a1.62,1.62,0,0,0,0-.22c0-.2,0-.38,0-.57-.22-2.88-2.11-4.86-4.43-4.92h-.09a4.26,4.26,0,0,0-3.61,2.1A5.51,5.51,0,0,0,44,29,6.27,6.27,0,0,0,43.71,30.48Zm4.51-3.72c.76,0,1.37.29,1.37.66s-.61.67-1.37.67-1.37-.3-1.37-.67S47.47,26.76,48.22,26.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M43.15,32.56a1.54,1.54,0,0,0,.69,1.25h0c0-.21-.07-.44-.1-.67,0,0,0-.11,0-.16a6.06,6.06,0,0,1,0-.75V31.17A1.46,1.46,0,0,0,43.15,32.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "51.33 37.06 51.33 37.06 51.33 38.12 51.33 37.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M51.2,39.3h0l.13-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M49.92,40.2h0l.14-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M50.78,39.68h0l.18-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M49.49,40.37l.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M51,37.42a5.45,5.45,0,0,1-.38.46l0,0A5,5,0,0,0,51,37.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M50.36,40h0l.14-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M51.06,37.32c-.14.19-.29.38-.45.56a5.45,5.45,0,0,0,.38-.46A.61.61,0,0,1,51.06,37.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M51.06,37.32c-.14.19-.29.38-.45.56a5.45,5.45,0,0,0,.38-.46A.61.61,0,0,1,51.06,37.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51.06,37.32a.61.61,0,0,0-.07.1,5,5,0,0,1-.41.5l-.06.08-.43.47a2.08,2.08,0,0,1-1.54.68h-.69l1.63,1.22h0l.11,0,.08,0,.24-.1.14-.06.09,0,.21-.12.14-.09.07,0,.21-.16.18-.14v0a2.39,2.39,0,0,0,.23-.22l.13-.13h0V37.06l-.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M51.06,37.32a.61.61,0,0,0-.07.1,5,5,0,0,1-.41.5l-.06.08-.43.47a2.08,2.08,0,0,1-1.54.68h-.69l1.63,1.22h0l.11,0,.08,0,.24-.1.14-.06.09,0,.21-.12.14-.09.07,0,.21-.16.18-.14v0a2.39,2.39,0,0,0,.23-.22l.13-.13h0V37.06l-.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M49.92,40.2l.23-.11-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M49.92,40.2l.23-.11-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M50.78,39.68l.19-.16v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M50.78,39.68l.19-.16v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M50.36,40l.21-.13-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M50.36,40l.21-.13-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M49.49,40.37h0l.19-.07-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M49.49,40.37h0l.19-.07-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M51.33,39.17l-.13.13.13-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M51.33,39.17l-.13.13.13-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M52.76,32.37v0h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M51.82,31.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M52.75,32.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M52.2,35.22l.08-.21a1.8,1.8,0,0,1-.08.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M52.61,33.81a13,13,0,0,0,.14-1.35h0s0-.06,0-.09V31.22h0l-.57.15-.12,0-.2.06h0a1,1,0,0,1-.35,0h-.08a1.12,1.12,0,0,1-.6-.26l0,0a.81.81,0,0,0-.14-.12c-.1-.08-.2-.17-.29-.23l-.23-.13-.21-.13-.24-.1-.19-.07-.16-.05-.22-.06H49a3.57,3.57,0,0,0-.72-.07h0l-.5,0-.27.05-.09,0L47,30.4l-.06,0-.33.14-.07,0a2.08,2.08,0,0,0-.38.22l-.08.05a3,3,0,0,0-.4.32,1.2,1.2,0,0,1-1.12.27l-.88-.24h0l8.51,4a1.8,1.8,0,0,0,.08-.21l.09-.22A7.79,7.79,0,0,0,52.61,33.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M52.61,33.81a13,13,0,0,0,.14-1.35h0s0-.06,0-.09V31.22h0l-.57.15-.12,0-.2.06h0a1,1,0,0,1-.35,0h-.08a1.12,1.12,0,0,1-.6-.26l0,0a.81.81,0,0,0-.14-.12c-.1-.08-.2-.17-.29-.23l-.23-.13-.21-.13-.24-.1-.19-.07-.16-.05-.22-.06H49a3.57,3.57,0,0,0-.72-.07h0l-.5,0-.27.05-.09,0L47,30.4l-.06,0-.33.14-.07,0a2.08,2.08,0,0,0-.38.22l-.08.05a3,3,0,0,0-.4.32,1.2,1.2,0,0,1-1.12.27l-.88-.24h0l8.51,4a1.8,1.8,0,0,0,.08-.21l.09-.22A7.79,7.79,0,0,0,52.61,33.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "52.75 31.21 52.75 31.22 52.75 31.22 52.75 31.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "52.75 31.21 52.75 31.22 52.75 31.22 52.75 31.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.76,32.33h0v0h0s0,.06,0,.09h0a13,13,0,0,1-.14,1.35h0a1.55,1.55,0,0,0,.69-1.24,1.51,1.51,0,0,0-.54-1.4v1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M43.69,31.21h0l.88.24a1.2,1.2,0,0,0,1.12-.27,3,3,0,0,1,.4-.32l.08-.05a2.08,2.08,0,0,1,.38-.22l.07,0,.33-.14.06,0,.33-.09.09,0,.27-.05a2.85,2.85,0,0,1,.5,0h0a3.57,3.57,0,0,1,.72.07h.11l.22.06.16.05.19.07.24.1.21.13.23.13c.09.06.19.15.29.23l.14.12,0,0a1.12,1.12,0,0,0,.6.26h.08a1,1,0,0,0,.35,0h0l.19-.05h0l.12,0,.57-.15h0a6.39,6.39,0,0,0-1.26-1c-.2-.13-.43-.25-.66-.37a6,6,0,0,0-2.61-.63h0a5.05,5.05,0,0,0-.68.07l-.14,0a4.15,4.15,0,0,0-.61.14l-.12,0-.54.19-.06,0c-.19.07-.36.16-.53.24l-.11.06-.46.25-.06,0-.36.24-.06,0-.32.23-.06.05-.22.19h0l-.13.12h0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M48.22,28.09c.76,0,1.37-.3,1.37-.67s-.61-.66-1.37-.66-1.37.29-1.37.66S47.47,28.09,48.22,28.09Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFamilleSelected);
export default __webpack_public_path__ + "static/media/icon_famille_selected.39a76107d37f406803ae482400dca7be.svg";
export { ForwardRef as ReactComponent };